function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M29.95 22.48l-1 1a1.73 1.73 0 01-1.22.51 1.68 1.68 0 01-1.21-.51l-3.94-3.93v9.43a1.61 1.61 0 01-1.71 1.57h-1.71a1.61 1.61 0 01-1.71-1.57v-9.43l-3.94 3.93a1.68 1.68 0 01-2.41 0l-1-1a1.7 1.7 0 01-.51-1.21 1.74 1.74 0 01.51-1.22l8.72-8.72a1.67 1.67 0 011.21-.5 1.72 1.72 0 011.22.5l8.72 8.72a1.78 1.78 0 01.5 1.22 1.75 1.75 0 01-.52 1.21z",
  fill: "#fff"
});

var SvgArrowCircleUp = function SvgArrowCircleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
};

export default SvgArrowCircleUp;